import React, { useContext, useCallback } from 'react';
import Spreadsheet from 'react-spreadsheet';
import { ChillerCircuit } from '../../model';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

interface YorkCircuitDetailsSubsectionProps {
  chillerCircuit: ChillerCircuit;
  col?: number;
}

const YorkCircuitDetailsSubsection: React.FunctionComponent<YorkCircuitDetailsSubsectionProps> = (props) => {
  let { chillerCircuit, col } = props;

  const { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved } =
    useContext(ChillerLogsContext);

  let classes = 'chiller-spreadsheet';
  if (col === 3) {
    classes += ' third-column';
  }

  const handleSpreadsheetChange = useCallback(
    (updatedData) => {
      updateChillerLogFieldIfChanged({
        chillerLog,
        setChillerLog,
        updatedData,
        currentFieldValue: chillerCircuit.york_circuit_details,
        getField: (log) => log.circuits[chillerCircuit.index].york_circuit_details,
        setField: (log, value) => {
          log.circuits[chillerCircuit.index].york_circuit_details = value;
        },
      });
    },
    [setChillerLog, chillerLog],
  );

  let readIndex = chillerCircuit?.index + 1;
  let tableData = useFormattedTableData(chillerCircuit?.york_circuit_details, col, currentLogApproved);
  let columnLabels = ['', '', '', `Circuit ${readIndex}`];

  return (
    chillerCircuit?.york_circuit_details?.length > 0 && (
      <Spreadsheet
        data={tableData}
        hideRowIndicators
        columnLabels={[columnLabels[col]]}
        onChange={handleSpreadsheetChange}
        className={classes}
        onBlur={saveCurrentLogToLocalStorage}
      />
    )
  );
};

export default YorkCircuitDetailsSubsection;
